import { Input } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';

@Component({
  selector: 'loyaltic-generic-pop-up',
  templateUrl: './generic-pop-up.component.html',
  styleUrls: ['./generic-pop-up.component.scss']
})
export class GenericPopUpComponent implements OnInit, AfterViewInit {

  @ViewChild('genericPopup', { static: false }) genericPopupRef: any;
  @Input() item : any;

  userId = '';
  showHomeAndReload = false;
  showHideModal = false;
  showHome = false;
  public modalRef!: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };


  constructor( private modalService: BsModalService,
    private dataService:DataServiceService,
     public translate: TranslateService,
     private router: Router,
     private authService: AuthService,
     private coreService: CoreService
     ) {
      this.userId = this.authService.getUserId();
  }

  ngOnInit() {
    console.log("this.item",this.item)
    if(this.item.headerKey == 'pop-invalid-img-header' || this.item.headerKey == 'heading-no-games-available'){
      this.showHome = true;
    } else if (this.item.headerKey === 'pop-max-upload-reached-header') {
      this.showHomeAndReload = true;
    }
     else {
      this.showHideModal = true;
    }
  }

  ngAfterViewInit() {
    this.modalRef = this.modalService.show(this.genericPopupRef, this.popupConfig);

  }
  navigateToHome() {
    this.modalRef.hide();
    this.router.navigate([this.router.url])
    // window.location.reload();
  }

  navigateToHomeAndReload() {
    this.modalRef.hide();
    this.router.navigate(['']);
    window.location.reload();
  }
}
